/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight (kg)`)
};

const es_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso (kg)`)
};

const de_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht (kg)`)
};

const nl_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht (kg)`)
};

const fr_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids (kg)`)
};

const it_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso (kg)`)
};

const pt_br2_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso (kg)`)
};

const pt_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso (kg)`)
};

const ja_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体重 (kg)`)
};

const zh_bmi_weight_kg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体重（千克）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_weight_kg = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_weight_kg(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_weight_kg", locale)
	if (locale === "en") return en_bmi_weight_kg(inputs)
	if (locale === "es") return es_bmi_weight_kg(inputs)
	if (locale === "de") return de_bmi_weight_kg(inputs)
	if (locale === "nl") return nl_bmi_weight_kg(inputs)
	if (locale === "fr") return fr_bmi_weight_kg(inputs)
	if (locale === "it") return it_bmi_weight_kg(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_weight_kg(inputs)
	if (locale === "pt") return pt_bmi_weight_kg(inputs)
	if (locale === "ja") return ja_bmi_weight_kg(inputs)
	return zh_bmi_weight_kg(inputs)
};